import './UserBadge.scss';

import UserBadge from './UserBadge';

export { UserBadge };
export default UserBadge;
